import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      maxWidth: 400,
      padding: theme.spacing(1),
      marginBottom: theme.spacing(3),
    },
  }),
);
